import Icon from "@mui/icons-material/PlaylistPlayRounded";

export default function WorkspaceIcon(props) {
	return <Icon color={props.color} />;
}
